import axios from 'axios';
import API_BACKEND_URL from '@/API_URL/api_back_end.js';
import { collectClientDeviceInfo } from '@/utils/clientDeviceInfo';
import { getUser } from '@/services/tokenStore';

const HEARTBEAT_LOCAL_KEY = 'usageHeartbeatAt';
const HEARTBEAT_LOCAL_MIN_MS = 6 * 60 * 60 * 1000;

/**
 * Meldet Geräte-/Nutzungsaktivität (gedrosselt lokal + serverseitig).
 * Fehler werden bewusst geschluckt — Statistik darf die App nicht stören.
 */
export async function sendUsageHeartbeat() {
    try {
        const user = getUser();
        if (!user?.token) {
            return;
        }

        const last = Number.parseInt(localStorage.getItem(HEARTBEAT_LOCAL_KEY) || '0', 10);
        if (last && Date.now() - last < HEARTBEAT_LOCAL_MIN_MS) {
            return;
        }

        const clientInfo = await collectClientDeviceInfo();
        await axios.post(`${API_BACKEND_URL}usage/heartbeat`, { clientInfo });
        localStorage.setItem(HEARTBEAT_LOCAL_KEY, String(Date.now()));
    } catch (err) {
        // ignore
    }
}
